import * as api from '../../requests'

export const fetchAndSetUserInfoItems = (callback) => (dispatch, getState) => {
    api.GET_USER_AND_ROLES(
      (data, props={}) => {
        dispatch(setUserInfo(data))
        if (callback) callback(data)
      },
      (err) => {
        dispatch(setUserInfoError(true))
        dispatch(setUserInfoErrorDetails({ message: err.Message, code: err.Code }))
      }
    )
  }

export const setUserInfo = (items) => ({
  type: 'SET_USERINFO_ITEMS',
  items
  //category,
})

export const setUserInfoError = (error) => ({
  type: 'SET_USERINFO_ERROR',
  error,
})

export const setUserInfoErrorDetails = (errorDetails) => ({
  type: 'SET_USERINFO_ERROR_DETAILS',
  errorDetails,
})